import LocalRepository from "../../repository/LocalRepository";

const state = () => ({
    isLogin: LocalRepository.isLogin(),
    user: LocalRepository.getUser(),

    loadingQueue: 0
})

// getters
const getters = {
    isLoading: (state, getters, rootState) => {
        return state.loadingQueue > 0
    },
}

// actions
const actions = {
    // addProductToCart ({ state, commit }, product) {
    //     commit('setCheckoutStatus', null)
    //     if (product.inventory > 0) {
    //         const cartItem = state.items.find(item => item.id === product.id)
    //         if (!cartItem) {
    //             commit('pushProductToCart', { id: product.id })
    //         } else {
    //             commit('incrementItemQuantity', cartItem)
    //         }
    //         // remove 1 item from stock
    //         commit('products/decrementProductInventory', { id: product.id }, { root: true })
    //     }
    // }
}

// mutations
const mutations = {
    addLoadingQueue (state) {
        state.loadingQueue++
    },

    removeLoadingQueue (state) {
        state.loadingQueue--
    },

    // incrementItemQuantity (state, { id }) {
    //     const cartItem = state.items.find(item => item.id === id)
    //     cartItem.quantity++
    // },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}